import React, { useContext, useEffect, useState } from "react"
import { Layout, Menu } from "antd"
import menuItems, { MenuItem } from "../../data/menuItems"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import { TitleContext } from "../../contexts/TitleContext"
import { AuthContext } from "../../contexts/auth/AuthContext"
import hasPermission from "../../utils/hasPermission"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import DraggableMenuButton from "../../components/button/DraggableMenuButton"
import MobileToolBar from "../../components/navigation/MobileToolBar"
import useSettings from "../../hooks/useSettings"
// import { useSwipeable } from "react-swipeable";
import BrandLogo from "../../components/brand/BrandLogo"

export default function Sidebar() {
  const screens = useBreakpoint()
  const [collapsed, setCollapsed] = useState(false)
  // const { ref } = useSwipeable({
  //   onSwipedRight: (eventData) => {
  //     if (eventData.absX > 50 && eventData.initial[0] < 30) setCollapsed(false);
  //   },
  //   onSwipedLeft: (eventData) => {
  //     if (eventData.absX > 50) setCollapsed(true);
  //   },
  // }) as { ref: RefCallback<Document> };

  const history = useHistory()
  const { pathname } = useLocation()
  const { setTitle } = useContext(TitleContext)
  const { authState } = useContext(AuthContext)
  const [settings] = useSettings()
  const isClient = authState.user?.userName === "Counterparty"
  const { t } = useTranslation(isClient ? "client" : "translation")
  function handleMenuItemClick(menuItem: MenuItem) {
    setTitle(menuItem.seoTitle)
    !screens.lg && !collapsed && setCollapsed(true)
    history.push(menuItem.link || menuItem.route)
  }

  // useEffect(() => {
  //   ref(document);
  // });

  useEffect(() => {
    setCollapsed(!screens.xl)
  }, [screens])

  useEffect(() => {
    // pathname.startsWith("/" + x.title) — обычная строковая проверка, без
    // границы сегмента. "/moneyReceipts" тоже начинается с "/money", поэтому
    // раньше подходил первый по порядку пункт меню — "money" (route "/moneys"),
    // и его заголовок «Офис Деньги» показывался на странице «Поступление
    // денег» (moneyReceipts). Теперь совпадение только по целому сегменту:
    // ровно "/" + title или "/" + title + "/...".
    const title = menuItems.find(
      (x) =>
        pathname === x.link ||
        pathname === x.route ||
        pathname === "/" + x.title ||
        pathname.startsWith("/" + x.title + "/")
    )?.seoTitle
    setTitle(title || "")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, setTitle])

  return (
    <>
      <Layout.Sider
        className={`custom-sider ${settings.toolbar ? "has-toolbar" : ""} ${
          !screens.lg ? "custom-sider-mobile" : ""
        } ${collapsed ? "custom-collapsed" : ""}`}
        collapsible
        collapsed={screens.lg ? collapsed : false}
        onCollapse={setCollapsed}
        {...(!screens.lg && { trigger: null })}
        // trigger={null}
        collapsedWidth={!screens.lg ? 0 : 80}
        width={250}
      >
        <div className="sidebar-brand-container" style={{ padding: "16px 12px", display: "flex", justifyContent: "center", borderBottom: "1px solid rgba(255, 255, 255, 0.08)" }}>
          <BrandLogo collapsed={screens.lg ? collapsed : false} showDemo={true} />
        </div>
        <Menu
          // theme="dark"
          className="MenuSaidbar_r"
          inlineIndent={0}
          key={pathname}
          selectedKeys={["/" + pathname.split("/")[1]]}
          mode="inline"
        >
          {menuItems
            .filter((x) => hasPermission(authState.user, x.link || x.route))
            .map((menuItem) => (
              <Menu.Item
                key={menuItem.link || menuItem.route}
                disabled={!menuItem.component}
                onClick={() => handleMenuItemClick(menuItem)}
                icon={<menuItem.icon />}
              >
                {t(menuItem.title)}
              </Menu.Item>
            ))}
        </Menu>
      </Layout.Sider>
      {!screens.lg &&
        (settings.toolbar ? (
          <MobileToolBar onMenuButtonClicked={() => setCollapsed(!collapsed)} />
        ) : (
          <DraggableMenuButton onClick={() => setCollapsed(!collapsed)} />
        ))}
    </>
  )
}
